import React from 'react';
import { Redirect } from 'react-router-dom';
import {connect} from "react-redux";
import {logout} from './../actions/auth';

import Page from 'components/Page';

import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
} from 'reactstrap';



class ForbiddenPage extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            redirectToHome:false,
        }
    }

    handleClick = () =>{
        this.setState({
            redirectToHome:true
        })
    }

    logout = () =>{
        this.props.logout();
      }

    render() {
        if(this.state.redirectToHome){
            return <Redirect to='/'/>
        }
        return (
            <Page
            className="ForbiddenPage"
            >
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <Card>
                            <CardBody>
                                <p className='display-1'>403</p>
                                <p>Forbidden</p>
                                <Button size='lg' color='primary' onClick={this.handleClick}>Volver al inicio</Button>
                                <Button size='lg' color='danger' onClick={this.logout}>Cerrar Sesión</Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Page>
        );
    }
}

const mapStateToProps = state => ({
    auth:state.auth,
  })
  
export default connect(mapStateToProps,{logout})(ForbiddenPage)